import React from 'react';

const Spinner = ({ grow = false, color = "success", size = 1 }) => {

    // Different text-color for spinner
    // ==> text-primary
    // ==> text-body
    // ==> text-success
    // ==> text-info
    // ==> text-danger
    // ==> text-warning
    // ==> text-info
    // ==> text-success
    // ==> text-light
    // ==> text-dark
    // var clr = 'success';


    return grow ?
        <div className={`spinner-grow text-${color}`} role="status" style={{ height: `${size}rem`, width: `${size}rem` }}>
            {/* <span className="visually-hidden">Loading...</span> */}
        </div>
        : <div className={`spinner-border text-${color}`} role="status" style={{ height: `${size}rem`, width: `${size}rem` }}>
            {/* <span className="visually-hidden">Loading...</span> */}
        </div>
}

export default Spinner;

